// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZuMch","right":"styles_right__3gTl5"};